import React from 'react';
import ReactDOM from 'react-dom';
import Config from '../../../constants/appConfig';
import Map3D from './map3D';

class RealTime3D extends React.Component {
  state = {
    jobs: [],
    planes: [],
    planeCatalog: [],
    dateIni: null,
    dateEnd: null,
    realTime3D: false
  };

  mounted = false;
  refreshTimer = null;
  refreshInProgress = false;
  refreshIntervalMs = 10000;

  componentDidMount() {
    this.mounted = true;

    const dayRange = this.getDayRange();
    this.setState({
      dateIni: dayRange.dateIniDate,
      dateEnd: dayRange.dateEndDate
    });

    this.readCompanySettings();
    this.readPlaneCatalog();
    this.refreshData();
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.refreshTimer) clearTimeout(this.refreshTimer);
    this.refreshTimer = null;
    this.refreshInProgress = false;
  }

  getDayRange = () => {
    const baseDate = new Date();
    baseDate.setHours(0, 0, 0, 0);

    const endDate = new Date(baseDate.getTime());
    endDate.setDate(endDate.getDate() + 1);

    return {
      dateIni: baseDate.getTime(),
      dateEnd: endDate.getTime(),
      dateIniDate: baseDate,
      dateEndDate: endDate
    };
  };

  getJobDates = (job) => {
    const dates = [];
    const addDate = (value) => {
      const numberValue = Number(value || 0);
      if (numberValue > 0) {
        dates.push(numberValue);
        return;
      }

      const parsed = value ? new Date(value).getTime() : 0;
      if (parsed > 0) dates.push(parsed);
    };

    const addItemDates = (item) => {
      if (!item) return;
      addDate(item.startDate);
      addDate(item.endDate);
      addDate(item.date);
      addDate(item.datetime);
      addDate(item.created);
      addDate(item.updated);
    };

    addItemDates(job);

    const lists = ['list_exe', 'list_plan', 'list_analise'];
    for (let i = 0; i < lists.length; i++) {
      const arr = Array.isArray(job[lists[i]]) ? job[lists[i]] : [];
      for (let j = 0; j < arr.length; j++) addItemDates(arr[j]);
    }

    return dates;
  };

  isJobInPeriod = (job, dateIni, dateEnd) => {
    if (!job || job.status === 'canceled' || job.status === 'deleted') return false;

    const dates = this.getJobDates(job);
    if (!dates.length) return true;

    for (let i = 0; i < dates.length; i++) {
      if (dates[i] >= dateIni && dates[i] < dateEnd) return true;
    }

    return false;
  };

  getPlaneDgpsId = (plane) => {
    if (!plane) return 0;

    const candidates = [plane.id_dgps, plane.idDgps, plane.idDGPS];
    for (let i = 0; i < candidates.length; i++) {
      const id = Number(candidates[i] || 0);
      if (id > 0) return id;
    }

    return 0;
  };

  getPlaneId = (item) => Number(item && (item.id || item.id_plane || item.idPlane) || 0);

  mergePlanes = (jobs, sourcePlanes, catalog) => {
    const planes = (Array.isArray(sourcePlanes) ? sourcePlanes : [])
      .filter(item => this.getPlaneDgpsId(item) > 0)
      .map(item => Object.assign({}, item));
    const planeCatalog = Array.isArray(catalog) ? catalog : [];
    const added = {};

    const addPlane = (item) => {
      const id = this.getPlaneId(item);
      if (id <= 0 || added[id]) return;

      const catalogPlane = planeCatalog.find(plane => this.getPlaneId(plane) === id) || {};
      const merged = Object.assign({}, item || {}, catalogPlane, { id: id });
      if (this.getPlaneDgpsId(merged) <= 0) return;

      added[id] = true;
      planes.push(merged);
    };

    for (let i = 0; i < planes.length; i++) {
      const id = this.getPlaneId(planes[i]);
      if (id > 0) added[id] = true;
    }

    const safeJobs = Array.isArray(jobs) ? jobs : [];
    for (let i = 0; i < safeJobs.length; i++) {
      const lists = ['list_plan', 'list_exe', 'list_analise'];
      for (let j = 0; j < lists.length; j++) {
        const items = Array.isArray(safeJobs[i][lists[j]]) ? safeJobs[i][lists[j]] : [];
        for (let k = 0; k < items.length; k++) addPlane(items[k]);
      }
    }

    return planes;
  };

  getJobFilters = () => {
    const dayRange = this.getDayRange();

    return {
      size: 1000,
      page: 1,
      dateini: dayRange.dateIni,
      datefim: dayRange.dateEnd,
      type: [],
      state: [],
      missing: [],
      planes: [],
      filtro: '',
      referencia: 'updated'
    };
  };

  loadJobs = () => {
    const apiUrl = `${Config.server}/job_list`;
    const options = {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.getJobFilters())
    };

    return fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        const jobs = Array.isArray(result && result.data) ? result.data : [];
        const dayRange = this.getDayRange();
        return jobs.filter(job => this.isJobInPeriod(job, dayRange.dateIni, dayRange.dateEnd));
      });
  };

  loadPlanes = () => {
    const dateIni = new Date();
    dateIni.setMonth(dateIni.getMonth() - 12);

    const dayRange = this.getDayRange();
    const apiUrl = `${Config.server}/plane_jobs/${dateIni.getTime()}/${dayRange.dateEnd}`;
    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    return fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => Array.isArray(result && result.planes) ? result.planes : []);
  };

  refreshData = () => {
    if (this.refreshInProgress) return;

    this.refreshInProgress = true;
    const dayRange = this.getDayRange();

    Promise.all([this.loadJobs(), this.loadPlanes()])
      .then((result) => {
        if (!this.mounted) return;

        const jobs = result[0];
        const sourcePlanes = result[1];
        this.setState((state) => ({
          jobs: jobs,
          planes: this.mergePlanes(jobs, sourcePlanes, state.planeCatalog),
          dateIni: dayRange.dateIniDate,
          dateEnd: dayRange.dateEndDate
        }));
      })
      .catch((error) => {
        if (error && (error.status === 401 || error.status === 403)) {
          this.props.link('/login');
        }
      })
      .then(() => {
        this.refreshInProgress = false;
        this.scheduleRefresh();
      });
  };

  scheduleRefresh = () => {
    if (this.refreshTimer) clearTimeout(this.refreshTimer);
    if (!this.mounted) return;

    this.refreshTimer = setTimeout(this.refreshData, this.refreshIntervalMs);
  };

  readPlaneCatalog = () => {
    const apiUrl = `${Config.server}/plane`;
    const apiUrlPerm = `${Config.server}/plane/perm`;
    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    Promise.all([fetch(apiUrl, options), fetch(apiUrlPerm, options)])
      .then((responses) => {
        for (let i = 0; i < responses.length; i++) {
          if (responses[i].status !== 200) throw responses[i];
        }
        return Promise.all(responses.map((res) => res.json()));
      })
      .then((result) => {
        if (!this.mounted) return;

        const planes = Array.isArray(result[0]) ? result[0] : [];
        const permPlanes = Array.isArray(result[1]) ? result[1] : [];
        const merged = [];
        const seen = {};

        for (let i = 0; i < planes.length; i++) {
          const plane = planes[i];
          if (plane && plane.id != null && !seen[plane.id]) {
            seen[plane.id] = true;
            merged.push(Object.assign({}, plane, {
              original_name: plane.name ? String(plane.name) : '',
              id_company: plane.id_company != null ? plane.id_company : null
            }));
          }
        }

        for (let i = 0; i < permPlanes.length; i++) {
          const plane = permPlanes[i];
          if (!plane || plane.id == null || seen[plane.id]) continue;

          const planeName = plane.name ? String(plane.name) : '';
          const companyName = plane.company_name ? String(plane.company_name) : '';

          seen[plane.id] = true;
          merged.push(Object.assign({}, plane, {
            original_name: planeName,
            name: companyName ? planeName + ' - ' + companyName : planeName,
            id_company: plane.id_company != null ? plane.id_company : null
          }));
        }

        this.setState((state) => ({
          planeCatalog: merged,
          planes: this.mergePlanes(state.jobs, state.planes, merged)
        }));
      })
      .catch((error) => {
        if (error && (error.status === 401 || error.status === 403)) {
          this.props.link('/login');
        }
      });
  };

  normalizeCompanySettings = (data) => {
    let company = data;

    if (company && company.data) company = company.data;
    if (Array.isArray(company)) company = company.length > 0 ? company[0] : null;
    if (!company) return { realTime3D: false };

    const realTime3DValue = company.realTime3D !== undefined
      ? company.realTime3D
      : (company.real_time_3d !== undefined ? company.real_time_3d : 0);

    return {
      realTime3D: realTime3DValue === true || realTime3DValue === 'true' || Number(realTime3DValue) === 1
    };
  };

  getLoggedCompanyIdFromToken = () => {
    try {
      const token = localStorage.getItem('access-token-jwt');
      if (!token) return null;

      const parts = token.split('.');
      if (parts.length < 2) return null;

      const payloadText = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
      const payload = JSON.parse(payloadText);
      return payload.id_company || payload.company_id || payload.idCompany || payload.companyId || null;
    } catch (_) {
      return null;
    }
  };

  readCompanySettings = () => {
    const companyId = this.getLoggedCompanyIdFromToken();
    const apiUrl = companyId ? `${Config.server}/company/${companyId}` : `${Config.server}/company/current`;
    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        if (!this.mounted) return;
        this.setState({ realTime3D: this.normalizeCompanySettings(result).realTime3D });
      })
      .catch((error) => {
        if (error && (error.status === 401 || error.status === 403)) {
          this.props.link('/login');
        }
      });
  };

  close = () => {
    this.props.link('/app/ciclo');
  };

  render() {
    const { res } = this.props;

    return ReactDOM.createPortal(
      <Map3D
        res={res}
        jobs={this.state.jobs}
        planes={this.state.planes}
        planeCatalog={this.state.planeCatalog}
        dateIni={this.state.dateIni}
        dateEnd={this.state.dateEnd}
        realTime3D={this.state.realTime3D}
        onClose={this.close}
      />,
      document.body
    );
  }
}

export default RealTime3D;
